module.exports = __webpack_public_path__ + "static/media/hero.a5faf45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/hero.png
// module id = 744
// module chunks = 0